<template>
  <div class="footer">
    <div class="imgs">
      <!-- <img class="logo" src="@/assets/img/homeImg/footer_icon.png" alt=""> -->
    </div>
    <div class="hotline">
      <div class="telBox">
        <!-- <a :href="'tel:' + '0854—7225893'">地址：平塘市长安南路银波大厦 客服热线：0854—7225893(24小时服务)</a> -->
        <!-- <a :href="'tel:' + '024-25814333'">客服热线：0854—7225893(24小时服务)</a> -->
      </div>
      <!-- <p style="margin-left: 15px">我们竭诚为您服务</p> -->
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>
<style lang="scss" scoped>
.footer {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  font-size: 0.2rem;
  font-weight: 500;
  color: #999999;
  padding: 0.3rem 0;
  .imgs{
    display: flex;
    align-items: center;
    margin-bottom: .2rem;
    .logo{
      width: 1.89rem;
      height: .36rem;
    }
    .name{
      height: 0.27rem;
      font-size: 0.28rem;
      font-family: PingFang SC;
      font-weight: 800;
      color: #007E59;
      margin-left: 0.3rem;
    }
  }
  .hotline{
    font-size: 0.2rem;
    font-family: PingFang SC;
    font-weight: bold;
    color: #333333;
    display: flex;
    .telBox{
      width: 4.44rem;
      a{
        font-size: .14rem;
        display: block;
        color: #999;
        line-height: 0.32rem;
      }
    }
  }
}
</style>
